import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

import { fontMerriweather, theme } from "shared/lib/styles";

export type SummaryBlockProps = {
  sentences: string[];
};

const Container = styled.div`
  grid-area: summary;

  margin-block-start: 16px;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 100%;
    max-inline-size: var(--content-tablet-up-max-inline-size);
    margin-block-start: 32px;
    margin-inline: auto;
  }

  ${theme.breakpoints.up("desktop")} {
    margin-block-start: 32px;
  }
`;

const Label = styled.div`
  color: #222222;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontMerriweather};
  line-height: 160%;

  ${theme.breakpoints.up("desktop")} {
    font-size: 18px;
  }
`;

const List = styled.ul`
  margin-block: 12px 0;
  padding-inline-start: 20px;

  color: #222222;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontMerriweather};
  line-height: 160%;

  list-style: disc outside;

  ${theme.breakpoints.up("desktop")} {
    font-size: 18px;
  }
`;

const Item = styled.li`
  margin-block-end: 12px;

  &:last-child {
    margin-block-end: 0;
  }
`;

export const SummaryBlock: FunctionComponent<SummaryBlockProps> = ({ sentences }) => (
  <Container>
    <Label>Summary</Label>
    <List>
      {sentences.map((sentence, index) => (
        <Item key={index}>{sentence}</Item>
      ))}
    </List>
  </Container>
);
